<modal *ngIf="show" [show]="show" [x]="false" (onClose)="onClose()">
    <div class="wrapper text-center">
      <div *ngIf="img" class="img">
        <img [src]="img" alt="">
      </div>
      <h3 class="modal-title text-bold mb-2">{{titleText}}</h3>
      <p class="text-sm">{{descriptionText}}</p>
      <div class="p-2"></div>
      <button class="btn btn-primary btn-block w-100" (click)="onClose()">{{actionText}}</button>
    </div>
  </modal>